// super-scripts.component.ts
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SuperScript } from 'app/models/super-script';
import { SuperScriptService } from 'app/services/super-script-service';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { SuperScriptModalComponent } from './super-script-modal/super-script-modal.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-super-scripts',
  templateUrl: './super-scripts.component.html',
})
export class SuperScriptsComponent implements OnInit {
  superScripts: SuperScript[];
  modalRef: MDBModalRef;
  superScriptForm: FormGroup;

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = true;

  constructor(
    private superScriptService: SuperScriptService,
    private modalService: MDBModalService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.loadSuperScripts();
    this.initForm();
  }

  initForm(): void {
    this.superScriptForm = this.fb.group({
      id: [null],
      function_name: ['', Validators.required],
      script: ['', Validators.required],
      annual_price_per_call: [0, Validators.required],
      monthly_price_per_call: [0, Validators.required],
      subscribed_amount: [0, Validators.required],
      free_amount: [0, Validators.required],
      current_usage: [0],
      overage_price_per_call: [0, Validators.required],
      display_name: ['', Validators.required],
      enabled: [false]
    });
  }

  loadSuperScripts(): void {
    this.tableLoadingIndicator = true;
    this.superScriptService.getAll().pipe(finalize(() => {
      this.tableLoadingIndicator = false;
    })) .subscribe(data => {
      this.superScripts = data;
    });
  }

  innerWidth(): number {
    return window.innerWidth;
  }

  openModal(mode: string): void {
    this.modalRef = this.modalService.show(SuperScriptModalComponent, {
      class: 'modal-xl modal-primary',
      ignoreBackdropClick: true,
      data: {
        form: this.superScriptForm,
        mode: mode
      }
    });

    this.modalRef.content.action.subscribe((result: {data: SuperScript, mode: 'add' | 'edit'}) => {

      if (result.mode === 'edit') {
        this.superScriptService.update(result.data).subscribe(updatedScript => {
          const index = this.superScripts.findIndex(s => s.id === updatedScript.id);
          this.superScripts[index] = updatedScript;
          this.superScripts = [...this.superScripts];
        });
      } else {
        this.superScriptService.create(result.data).subscribe(newScript => {
          this.superScripts.push(newScript);
          this.superScripts = [...this.superScripts];
        });
      }
    });
  }

  editSuperScript(script: SuperScript): void {
    this.superScriptForm.patchValue(script);
    this.openModal('edit');
  }
}
